<template>
  <div>
    <div class="row-tb-head" style="margin-top: 10px">
      <span>组合信息</span>
    </div>
    <el-table
      ref="table"
      class="table_bottom table-line tb-c-head"
      :data="tableData"
      key="t1"
      border
    >
      <el-table-column
        prop="ProductName"
        label="产品组合名称"
        min-width="160"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="ProductSpec"
        label="规格"
        min-width="110"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="PdUnitName"
        label="单位"
        min-width="126"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="ColorName"
        label="颜色"
        min-width="126"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="Quantity"
        label="需求数量"
        min-width="110"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="ImgUrl"
        label="图片"
        min-width="110"
        align="center"
      >
        <template slot-scope="{ row }">
          <el-button type="text" @click="viewImg(row)"
            >{{row.ProductId ? '查看' : ''}}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="ProcessStage"
        label="加工阶段"
        min-width="110"
        align="center"
      >
        <template slot-scope="{ row }">
          <span>{{ row.ProcessStage === 4 ? "组装" : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="ProduceTypeName"
        label="存货类型"
        min-width="110"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="Bomno"
        label="bom版本"
        min-width="110"
        align="center"
      >
      </el-table-column>
    </el-table>

    <div class="row-tb-head" style="margin-top: 10px">
      <span>工艺</span>
    </div>
    <el-table
      :data="ProcessData"
      class="table_bottom table-line tb-c-head"
      border
      key="t2"
      ref="list3"
    >
      <el-table-column
        prop="ProductName"
        label="产品名称"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="ProductNo"
        label="产品编码"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="ProgrammeName"
        label="工艺方案名称"
        min-width="120"
      >
      </el-table-column>
       <el-table-column
        label="方案详情"
        min-width="120"
      >
        <template slot-scope="{ row }">
           <el-button type="text" @click="changeProgrammeInfo(row)">详情编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div v-for="(item, index) in detailData" :key="index">
      <div class="row-tb-head" style="margin-top: 10px">
        <span>{{ item.name }}子件信息</span>
      </div>
      <el-table
        key="t3"
        ref="sub_table"
        class="table_bottom table-line tb-c-head"
        :data="item.DetailModels"
        border
      >
        <el-table-column
          prop="ProductNo"
          label="子件编码"
          min-width="110"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="ProductName"
          label="子件名称"
          min-width="110"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="ProductSpec"
          label="规格"
          min-width="110"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="PdUnitName"
          label="单位"
          min-width="126"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="ColorName"
          label="颜色"
          min-width="126"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="Quantity"
          label="需求数量"
          min-width="126"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="ImgUrl"
          label="图片"
          min-width="110"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-button type="text" @click="viewImg(row)">{{row.ProductId ? '查看' : ''}}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="ProcessStage"
          label="加工阶段"
          min-width="110"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>{{ (() => {
                
                if(row.ProcessStage === 3){
                  return '装配'
                }else if(row.ProcessStage === 1){
                  return '注塑'
                }else if(row.ProcessStage === 2){
                  return '配件'
                }else if(row.ProcessStage === 0){
                  return '无'
                }else if(row.ProcessStage === 4){
                  return '组装'
                }
              
              })()  }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="ProduceTypeName"
          label="存货类型"
          min-width="110"
          align="center"
        >
        </el-table-column>
      </el-table>
    </div>
    
    <come-list-dialog
      @select="comeSelect"
      :multiple="false"
      ref="comeListDialog"
      in-dialog
    />
    <img-dialog ref="imgDialog" :imgs="imgs" />
    <list-dialog ref="listDialog" selectable :multiple="false" @select="listDialogSelect"></list-dialog>
    <detail-dialog ref="detailDialog" @saved="detail_saved"></detail-dialog>
  </div>
</template>

<script>
import accountSelect from "@/components/production/clothmanagement/cloth/select";
import bomDialog from "./bomDialog";
import comeListDialog from "@/components/basedata/business/come/listDialog";
import imgDialog from "./imgDialog";
import listDialog from '@/components/production/craftsmanship/solutions/assemble/listDialog'
import detailDialog from "./detailDialog";
import { urlHttp } from './bomConfig'


export default {
  name: "wjCombination",
  components: {
    bomDialog,
    accountSelect,
    comeListDialog,
    imgDialog,
    listDialog,
    detailDialog,
  },
  props: {
    combination: {
      type: Array,
      default: () => [],
    },
    productData: {
      type: Array,
      default: () => [],
    },
    processListProp: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    combination(data) {
      console.log('combination data', data)
      let arr = [];
      let ProcessData = [];
      let detailData = [];
      data.forEach(item => {
        let {DetailModels, ProcessModels, ...rest} = item;
        arr.push(rest);
        ProcessModels.forEach(v => {
          v.ProductName = rest.ProductName;
          v.ProductNo = rest.ProductNo;
        })
        ProcessData.push(...ProcessModels);
        let o = {
          name: rest.ProductName,
          DetailModels
        }
        detailData.push(o)
      })
      this.tableData = arr;
      this.ProcessData = ProcessData;
      this.detailData = detailData;
    },
    
  },
  data() {
    return {
      tableData: [],
      ProcessData: [],
      detailData: [],
      pdApi: require("@/api/ba/product").default,
      teProcessApi: require("@/api/production/teProcess").default,
      processList: [],
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      tempItem: {},
      currentRow: null,
      imgs: [],
      colorList: [],
      craftData: [],
      subTableData: [],
      delTable: [],
      columns: [
        {
          key: "Pname",
          prop: "Pname",
          lable: "产品组合名称",
        },
        {
          key: "ProductSpec",
          prop: "ProductSpec",
          lable: "规格",
        },
        {
          key: "PdUnitName",
          prop: "PdUnitName",
          lable: "单位",
        },
        {
          key: "ColorName",
          prop: "ColorName",
          lable: "颜色",
        },
        {
          key: "ImgUrl",
          prop: "ImgUrl",
          lable: "图片",
        },
         {
          key: "ProcessStage",
          prop: "ProcessStage",
          lable: "加工阶段",
        },
        {
          key: "ProduceTypeName",
          prop: "ProduceTypeName",
          lable: "存货类型",
        },
        {
          key: "Bomno",
          prop: "Bomno",
          lable: "BOM版本",
        },
      ],
      innerColumns: [
        {
          key: "ProductNo",
          prop: "ProductNo",
          lable: "子件编码",
        },
        {
          key: "ProductName",
          prop: "ProductName",
          lable: "子件名称",
        },
        {
          key: "ProductSpec",
          prop: "ProductSpec",
          lable: "规格",
        },
        {
          key: "PdUnitName",
          prop: "PdUnitName",
          lable: "单位",
        },
        {
          key: "ColorName",
          prop: "ColorName",
          lable: "颜色",
        },
        {
          key: "ImgUrl",
          prop: "ImgUrl",
          lable: "图片",
        },
        {
          key: "ProcessStage",
          prop: "ProcessStage",
          lable: "加工阶段",
        },
        {
          key: "ProduceTypeName",
          prop: "ProduceTypeName",
          lable: "存货类型",
        },
      ],
    };
  },
  created() {

   
      // this.pdApi.list({ Status: 1 }).then((res) => {

      //     let data = res.Data.filter(item => {
      //       return item.ProcessStage === 0 || item.ProcessStage === 3
      //     })
            
          // this.DAccount = data;
          // this.initDAccount = data;
          // this.listTotal = data.length;
          // this.initTotal = data.length;
      // });

    // this.teProcessApi.list({}).then((res) => {
    //   if (res.Code === 0) {
    //     this.processList = res.Data;
    //   }
    // });
  },
  methods: {
    changeProgramme(row){
      this.currentRow = row
      this.$refs.listDialog.open()
    },
    changeProgrammeInfo(row){
      this.currentRow = row
      this.$refs.detailDialog.open().then(that => {
        that.setTableData(row)
      })
      console.log('row', row)
    },
    listDialogSelect(list){
      this.currentRow.ProgrammeName = list.ProgrammeName;
      this.currentRow.Processes = list.Processes;
      this.currentRow.ProgrammeId = list.ProgrammeId;


    },
    detail_saved(list){
      this.currentRow.Processes = list;
    },
    selectCome(row) {
      this.currentRow = row;
      this.$refs.comeListDialog.open();
    },
    comeSelect(row) {
      this.currentRow.TradeUnitId = row.TradeUnitId;
      this.currentRow.FullName = row.FullName;
    },
    setSubTableData(arr) {
      // 父组件调用，设置子件列表
      this.subTableData = arr;
    },
    setCraftData(data, Pname, Pno){
      let arr = [];

      if(data.length !== 0){
        data.forEach(item => {
          item.T = 1
        })

        let o = {
          ProductName: Pname,
          ProductNo: Pno,
          ProgrammeId: data[0].ProgrammeId,
          ProgrammeName: data[0].ProgrammeName,
          Processes: data
        }

        arr.push(o)

        this.craftData = arr;
      }else{
        this.craftData = [];
      }
    },
    base64ToFile(dataurl, filename) {//将base64转换为文件
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type:mime});
    },
    async viewImg(row) {
      const res = await this.pdApi.productImgList(row.ProductId)
      if (res.Code != 0) return this.$message.warning(res.Msg);
      const ImgUrl = res.Data;
      if (!ImgUrl || ImgUrl?.length < 1) return this.$message.warning('无图片！');
      let imgs = [];
      ImgUrl.forEach(item => {
        // const imgBlob = URL.createObjectURL(this.base64ToFile(item.ImgUrl));
        // imgs.push(imgBlob);
        imgs.push('/api' + item.ImgUrl)
      })
      this.imgs = imgs;
      this.$refs.imgDialog.open();
    },
    // viewImg(ImgUrl) {
    //   let imgs = ImgUrl.split(",");
    //   imgs.forEach((item) => {
    //     item = urlHttp + item;
    //   });

    //   this.imgs = imgs;
    //   this.$refs.imgDialog.open();
    // },
   
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}
</style>
